import React, { useState } from "react";
import useModulosForm from "../../../hooks/useModulosForm";
import apibig from "../../../components/Apibig";
import ModalModulo from "../../../components/ModalModulo";
import TablaDatosModulos from "../../../components/TablaDatosModulos";

const initialForm = {
  Id: 0,
  RolId: 0,
  Titulo: "",
  Clave: "",
  Clavep: "",
  Icono: "",
  Ruta: "",
  Win: false,
  Orden: "",
  URL: "",
  appid: "",
};

const Modulos = ({ autusuario }) => {
  const { datos, setDatos, loading, error } = useModulosForm(
    initialForm,
    autusuario,
    apibig
  );

  const [modalOpen, setModalOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [itemToDelete, setItemToDelete] = useState(null);
  const [deleting, setDeleting] = useState(false);
  const [showConfirmDelete, setShowConfirmDelete] = useState(false);

  const refrescarDatos = async () => {
    try {
      const autusuarioData = JSON.parse(sessionStorage.getItem("data"));
      const res = await apibig.post("/api/roles/getmodulos", {
        appid: autusuarioData.appid,
        basedatos: autusuarioData.basedatos,
      });
      setDatos(res.data);
    } catch (err) {
      console.error("Error al refrescar datos", err);
    }
  };

  const handleEdit = (item) => {
    setSelectedItem(item);
    setModalOpen(true);
  };

  const handleAdd = () => {
    setSelectedItem(null);
    setModalOpen(true);
  };

  const handleDeleteModulo = (item) => {
    setItemToDelete(item);
    setShowConfirmDelete(true);
  };

  const confirmDeleteModulo = async () => {
    if (itemToDelete) {
      setDeleting(true);
      const autusuarioData = JSON.parse(sessionStorage.getItem("data"));
      try {
        await apibig.post(`/api/roles/deletemodulo`, {
          appid: autusuarioData.appid,
          basedatos: autusuarioData.basedatos,
          id: itemToDelete.Id,
        });
        // Actualizar lista localmente después de borrar
        setDatos((prev) => prev.filter((r) => r.Id !== itemToDelete.Id));
      } catch (err) {
        console.error("Error eliminando módulo", err);
      }
      setItemToDelete(null);
      setShowConfirmDelete(false);
      setDeleting(false);
    }
  };

  if (loading)
    return (
      <div className="text-center pt-[10rem] text-[4rem]">Cargando modulos...</div>
    );
  if (deleting)
    return (
      <div className="text-center pt-[10rem] text-[4rem]">Eliminando módulo...</div>
    );
  if (error)
    return (
      <div className="text-red-500 text-center text-[4rem] pt-[15rem]">{error}</div>
    );

  return (
    <div className="flex flex-col items-center p-4">
      <button
        onClick={handleAdd}
        className="mb-4 px-4 py-2 bg-green-600 text-white rounded hover:bg-green-700"
      >
        Agregar Módulo
      </button>

      <TablaDatosModulos datos={datos} onEdit={handleEdit} onDelete={handleDeleteModulo} />

      <ModalModulo
        datos={datos}
        isOpen={modalOpen}
        onClose={() => setModalOpen(false)}
        selectedItem={selectedItem}
        onSave={refrescarDatos} // <-- Aquí pasa la función para refrescar
      />

      {showConfirmDelete && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
          <div className="bg-white p-6 rounded-lg shadow-xl text-center w-[90%] max-w-md">
            <h2 className="text-xl font-semibold mb-4">¿Confirmar eliminación?</h2>
            <p className="mb-6">
              ¿Estás seguro de que deseas eliminar el módulo{" "}
              <strong>{itemToDelete?.Titulo}</strong>?
            </p>
            <div className="flex justify-center gap-4">
              <button
                className="bg-red-600 text-white px-4 py-2 rounded hover:bg-red-700"
                onClick={confirmDeleteModulo}
              >
                Sí, eliminar
              </button>
              <button
                className="bg-gray-300 px-4 py-2 rounded hover:bg-gray-400"
                onClick={() => setShowConfirmDelete(false)}
              >
                Cancelar
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Modulos;
